import "./InputText.scss"

const InputText = ({ config, disabled = false }) => {
  return (
    <div className="inputtext">
      {config.heading && <h5 className="h5 font-semibold">{config.heading}</h5>}
      <div>
        <label>{config.label}</label>
        <input className="w-full" type="text" placeholder={config.placeholder} maxLength={config.maxLength} disabled={disabled} />
      </div>
    </div>
  )
}

export default InputText
